import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { getIsSinglePageIframed } from 'utils/bolt/client';

export default class BoltApp extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();
		if (getIsSinglePageIframed()) {
			document.body.classList.add('singlePageIframed');
		}
	}
}
